import { forwardRef } from 'react';

/**
 * Shared textarea — matches Input styling language.
 */
export const Textarea = forwardRef(function Textarea(
  { size = 'md', error = false, className = '', rows = 4, ...props },
  ref,
) {
  const sizeClasses =
    size === 'lg'
      ? 'px-4 sm:px-5 py-3 rounded-input text-body sm:text-body-xl'
      : 'px-3 sm:px-4 py-2.5 rounded-xl text-xs sm:text-sm';

  return (
    <textarea
      ref={ref}
      rows={rows}
      className={`w-full bg-input-background border font-sf-pro-display text-text-primary placeholder-text-muted focus:outline-none transition-all resize-y min-h-[96px] disabled:bg-gray-200/80 disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed disabled:opacity-85 ${sizeClasses} ${
        error
          ? 'border-status-error focus:border-status-error focus:ring-[3px] focus:ring-status-error/15'
          : 'border-border-default focus:border-primary focus:ring-[3px] focus:ring-primary/15'
      } ${className}`}
      {...props}
    />
  );
});
